export default "__VITE_ASSET__DxaTIwoZ__"